var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 328,
    viewBox: "0 0 539 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_3200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.856 112.814C376.063 130.089 424.61 -60.9407 311.835 20.1456C266.985 52.392 202.406 13.3698 140.562 34.6967C83.7673 54.2862 97.7565 118.557 103.253 139.587C114.353 182.065 59.0674 165.123 27.0206 183.374C-23.2469 212.002 20.8488 327.421 68.3356 327.902C115.823 328.383 464.712 326.944 464.712 326.944C464.712 326.944 485.435 310.731 496.441 277.316C518.998 208.813 531.751 97.6026 458.856 112.814Z",
    fill: "#EBF2F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.09 282.894H437.641V327.091H459.09V282.894Z",
    fill: "#DCEAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09 158.959V139.644H148.955V106.431H180.395V139.644H209.789V94.1196L242.225 81.8411V120.656H249.622V68.9668L282.059 79.717V157.354H323.082V203.212H338.409V214.765H373.615V194.871H393.83V140.815H418.8V240.602H443.769V327.433H418.8H397.397H393.83H373.615H362.189H343.889H338.409H323.082H308.683H282.059H273.905H257.683H249.622H242.225H225.246H213.688H209.789H180.395H149.48H148.955H143.09H118.039V158.959H143.09Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.329 91.6589H277.211V83.6454H255.329V91.6589Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.329 106.712H277.211V98.6982H255.329V106.712Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.329 120.255H277.211V112.241H255.329V120.255Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.797 177.234H393.365V189.602H418.797V177.234Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.799 215.198H393.609V227.567H418.799V215.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.799 233.883H393.609V246.251H418.799V233.883Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.02 265.796H419.209V253.428H394.02V265.796Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.209 272.572H394.02V284.941H419.209V272.572Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.02 304.486H419.209V292.118H394.02V304.486Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.954 112.241H214.939V120.255H237.954V112.241Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.954 98.8215H214.939V106.835H237.954V98.8215Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.768 125.373H214.939V133.386H277.768V125.373Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.768 137.421H214.939V145.435H277.768V137.421Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.768 149.388H214.939V157.095H277.768V149.388Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.799 196.514H393.609V208.882H418.799V196.514Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.799 164.87H311.301V172.62H316.799V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.516 164.87H301.018V172.62H306.516V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.463 164.87H290.965V172.62H296.463V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.932 164.87H281.434V172.62H286.932V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 164.87H271.719V172.62H277.217V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.393 164.87H261.895V172.62H267.393V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11 164.87H251.611V172.62H257.11V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.057 164.87H241.559V172.62H247.057V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.526 164.87H232.027V172.62H237.526V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.811 164.87H222.312V172.62H227.811V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 164.87H212.189V172.62H217.688V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.405 164.87H201.906V172.62H207.405V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 164.87H191.854V172.62H197.352V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 164.87H182.322V172.62H187.821V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.108 164.87H172.609V172.62H178.108V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 164.87H162.783V172.62H168.282V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.999 164.87H152.5V172.62H157.999V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.946 164.87H142.447V172.62H147.946V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.415 164.87H132.916V172.62H138.415V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.702 164.87H123.203V172.62H128.702V164.87Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.799 178.547H311.301V186.297H316.799V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.516 178.547H301.018V186.297H306.516V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.463 178.547H290.965V186.297H296.463V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.932 178.547H281.434V186.297H286.932V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 178.547H271.719V186.297H277.217V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.393 178.547H261.895V186.297H267.393V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11 178.547H251.611V186.297H257.11V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.057 178.547H241.559V186.297H247.057V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.526 178.547H232.027V186.297H237.526V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.811 178.547H222.312V186.297H227.811V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 178.547H212.189V186.297H217.688V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.405 178.547H201.906V186.297H207.405V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 178.547H191.854V186.297H197.352V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 178.547H182.322V186.297H187.821V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.108 178.547H172.609V186.297H178.108V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 178.547H162.783V186.297H168.282V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.999 178.547H152.5V186.297H157.999V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.946 178.547H142.447V186.297H147.946V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.415 178.547H132.916V186.297H138.415V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.702 178.547H123.203V186.297H128.702V178.547Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.799 192.013H311.301V199.763H316.799V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.516 192.013H301.018V199.763H306.516V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.463 192.013H290.965V199.763H296.463V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.932 192.013H281.434V199.763H286.932V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 192.013H271.719V199.763H277.217V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.393 192.013H261.895V199.763H267.393V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11 192.013H251.611V199.763H257.11V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.057 192.013H241.559V199.763H247.057V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.526 192.013H232.027V199.763H237.526V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.811 192.013H222.312V199.763H227.811V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 192.013H212.189V199.763H217.688V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.405 192.013H201.906V199.763H207.405V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 192.013H191.854V199.763H197.352V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 192.013H182.322V199.763H187.821V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.108 192.013H172.609V199.763H178.108V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 192.013H162.783V199.763H168.282V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.999 192.013H152.5V199.763H157.999V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.946 192.013H142.447V199.763H147.946V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.415 192.013H132.916V199.763H138.415V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.702 192.013H123.203V199.763H128.702V192.013Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.799 206.321H311.301V214.071H316.799V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.516 206.321H301.018V214.071H306.516V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.463 206.321H290.965V214.071H296.463V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.932 206.321H281.434V214.071H286.932V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 206.321H271.719V214.071H277.217V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.393 206.321H261.895V214.071H267.393V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11 206.321H251.611V214.071H257.11V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.057 206.321H241.559V214.071H247.057V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.526 206.321H232.027V214.071H237.526V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.811 206.321H222.312V214.071H227.811V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 206.321H212.189V214.071H217.688V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.405 206.321H201.906V214.071H207.405V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 206.321H191.854V214.071H197.352V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 206.321H182.322V214.071H187.821V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.108 206.321H172.609V214.071H178.108V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 206.321H162.783V214.071H168.282V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.999 206.321H152.5V214.071H157.999V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.946 206.321H142.447V214.071H147.946V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.415 206.321H132.916V214.071H138.415V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.702 206.321H123.203V214.071H128.702V206.321Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.799 219.998H311.301V227.748H316.799V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.516 219.998H301.018V227.748H306.516V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.463 219.998H290.965V227.748H296.463V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.932 219.998H281.434V227.748H286.932V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 219.998H271.719V227.748H277.217V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.393 219.998H261.895V227.748H267.393V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11 219.998H251.611V227.748H257.11V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.057 219.998H241.559V227.748H247.057V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.526 219.998H232.027V227.748H237.526V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.811 219.998H222.312V227.748H227.811V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 219.998H212.189V227.748H217.688V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.405 219.998H201.906V227.748H207.405V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 219.998H191.854V227.748H197.352V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 219.998H182.322V227.748H187.821V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.108 219.998H172.609V227.748H178.108V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 219.998H162.783V227.748H168.282V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.999 219.998H152.5V227.748H157.999V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.415 219.998H132.916V227.748H138.415V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.946 219.998H142.447V227.748H147.946V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.702 219.998H123.203V227.748H128.702V219.998Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.799 233.464H311.301V241.214H316.799V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.516 233.464H301.018V241.214H306.516V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.463 233.464H290.965V241.214H296.463V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.932 233.464H281.434V241.214H286.932V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.217 233.464H271.719V241.214H277.217V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.393 233.464H261.895V241.214H267.393V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.11 233.464H251.611V241.214H257.11V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.057 233.464H241.559V241.214H247.057V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.526 233.464H232.027V241.214H237.526V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.811 233.464H222.312V241.214H227.811V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.688 233.464H212.189V241.214H217.688V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.405 233.464H201.906V241.214H207.405V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.352 233.464H191.854V241.214H197.352V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 233.464H182.322V241.214H187.821V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.108 233.464H172.609V241.214H178.108V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.282 233.464H162.783V241.214H168.282V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.999 233.464H152.5V241.214H157.999V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.415 233.464H132.916V241.214H138.415V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.702 233.464H123.203V241.214H128.702V233.464Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1079 218.144H64.875V300.901H77.1079V218.144Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1083 325.941H90.2402V268.458H77.1083V325.941Z",
    fill: "#ADC9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67 194.835V178.716H364.007V194.835H354.936V214.73H373.618V194.835H364.67Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.799 153.206V140.838H413.543V135.454H412.881V140.838H393.717H393.366H389.742V135.454H389.08V140.838H384.428V194.887H393.717V171.6H418.799V159.231H393.717V153.206H418.799Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.254 230.188V299.952H77.1094V218.144L147.254 230.188Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7442 327.091H147.252V268.243H59.7442L59.7442 327.091Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7442 252.542H147.252V233.414H59.7442V252.542Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.296 284.198H136.801V290.533H141.296V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.892 284.198H128.396V290.533H132.892V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.675 284.198H120.18V290.533H124.675V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.884 284.198H112.389V290.533H116.884V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.944 284.198H104.449V290.533H108.944V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.913 284.198H96.418V290.533H100.913V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5107 284.198H88.0156V290.533H92.5107V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2939 284.198H79.7988V290.533H84.2939V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5048 284.198H72.0098V290.533H76.5048V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5634 284.198H64.0684V290.533H68.5634V284.198Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.296 295.377H136.801V301.712H141.296V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.892 295.377H128.396V301.712H132.892V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.675 295.377H120.18V301.712H124.675V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.884 295.377H112.389V301.712H116.884V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.944 295.377H104.449V301.712H108.944V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.913 295.377H96.418V301.712H100.913V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5107 295.377H88.0156V301.712H92.5107V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2939 295.377H79.7988V301.712H84.2939V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5048 295.377H72.0098V301.712H76.5048V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5634 295.377H64.0684V301.712H68.5634V295.377Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.296 261.676H136.801V268.01H141.296V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.892 261.676H128.396V268.01H132.892V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.675 261.676H120.18V268.01H124.675V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.884 261.676H112.389V268.01H116.884V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.944 261.676H104.449V268.01H108.944V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.913 261.676H96.418V268.01H100.913V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5107 261.676H88.0156V268.01H92.5107V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2939 261.676H79.7988V268.01H84.2939V261.676Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.296 272.853H136.801V279.187H141.296V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.892 272.853H128.396V279.187H132.892V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.675 272.853H120.18V279.187H124.675V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.884 272.853H112.389V279.187H116.884V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.944 272.853H104.449V279.187H108.944V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.913 272.853H96.418V279.187H100.913V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5107 272.853H88.0156V279.187H92.5107V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2939 272.853H79.7988V279.187H84.2939V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5048 272.853H72.0098V279.187H76.5048V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5634 272.853H64.0684V279.187H68.5634V272.853Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.296 306.385H136.801V312.719H141.296V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.892 306.385H128.396V312.719H132.892V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.675 306.385H120.18V312.719H124.675V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.884 306.385H112.389V312.719H116.884V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.944 306.385H104.449V312.719H108.944V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.913 306.385H96.418V312.719H100.913V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5107 306.385H88.0156V312.719H92.5107V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2939 306.385H79.7988V312.719H84.2939V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5048 306.385H72.0098V312.719H76.5048V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5634 306.385H64.0684V312.719H68.5634V306.385Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1088 205.006H81.8125V221.594H83.1088V205.006Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.577 238.787H136.801V245.32H140.577V238.787Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.083 238.787H99.3066V245.32H103.083V238.787Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2563 238.787H69.4805V245.32H73.2563V238.787Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.295 253.428H254.361V327.091H380.295V253.428Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.014 260.979H259.299V271.23H266.014V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.856 260.979H271.141V271.23H277.856V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.774 260.979H283.059V271.23H289.774V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.616 260.979H294.9V271.23H301.616V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.809 260.979H307.094V271.23H313.809V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.649 260.979H318.934V271.23H325.649V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.569 260.979H330.854V271.23H337.569V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.409 260.979H342.693V271.23H349.409V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.827 260.979H355.111V271.23H361.827V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.667 260.979H366.951V271.23H373.667V260.979Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.014 276.141H259.299V286.392H266.014V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.856 276.141H271.141V286.392H277.856V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.774 276.141H283.059V286.392H289.774V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.616 276.141H294.9V286.392H301.616V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.809 276.141H307.094V286.392H313.809V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.649 276.141H318.934V286.392H325.649V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.569 276.141H330.854V286.392H337.569V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.409 276.141H342.693V286.392H349.409V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.827 276.141H355.111V286.392H361.827V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.667 276.141H366.951V286.392H373.667V276.141Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.014 292.425H259.299V302.676H266.014V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.856 292.425H271.141V302.676H277.856V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.774 292.425H283.059V302.676H289.774V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.616 292.425H294.9V302.676H301.616V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.809 292.425H307.094V302.676H313.809V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.649 292.425H318.934V302.676H325.649V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.569 292.425H330.854V302.676H337.569V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.409 292.425H342.693V302.676H349.409V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.827 292.425H355.111V302.676H361.827V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.667 292.425H366.951V302.676H373.667V292.425Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.014 307.587H259.299V317.837H266.014V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.856 307.587H271.141V317.837H277.856V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.774 307.587H283.059V317.837H289.774V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.616 307.587H294.9V317.837H301.616V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.809 307.587H307.094V317.837H313.809V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.649 307.587H318.934V317.837H325.649V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.569 307.587H330.854V317.837H337.569V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.409 307.587H342.693V317.837H349.409V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.827 307.587H355.111V317.837H361.827V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.667 307.587H366.951V317.837H373.667V307.587Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.91 256.792H363.191V233.883L336.91 243.943V256.792Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.392 327.091H147.252V261.676L207.392 282.493V327.091Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 284.658H148.842V286.68H205.804V284.658Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 291.156H148.842V293.178H205.804V291.156Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 297.654H148.842V299.676H205.804V297.654Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 304.152H148.842V306.174H205.804V304.152Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 310.65H148.842V312.671H205.804V310.65Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.804 317.145H148.842V319.167H205.804V317.145Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.243 233.883H363.189V253.43H368.243V233.883Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.637 250.405V243.69H347.386V250.405H357.637Z",
    fill: "#D5E7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.118 109.158H152.633V138.72H156.118V109.158Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.048 109.158H159.562V138.72H163.048V109.158Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.886 109.158H166.4V138.72H169.886V109.158Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.96 109.158H173.475V138.72H176.96V109.158Z",
    fill: "#C4D9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.003 309.552H52.748L65.7106 261.676H372.003V309.552Z",
    fill: "#1C2948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.645 69.3035C94.8701 69.3035 65.8633 98.3031 65.8633 134.076C65.8633 169.85 130.641 234.138 130.641 234.138C130.641 234.138 195.416 169.85 195.416 134.076C195.416 98.3031 166.428 69.3035 130.645 69.3035ZM130.645 172.421C106.371 172.421 86.6954 152.744 86.6954 128.471C86.6954 104.199 106.371 84.5235 130.645 84.5235C154.918 84.5235 174.594 104.207 174.594 128.471C174.594 152.736 154.929 172.421 130.645 172.421Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.131 319.253C478.634 320.925 476.334 322.05 476.024 324.101C475.782 325.692 474.979 326.72 474.111 327.103H467.942C467.795 326.712 467.609 325.738 469.181 325.393C471.172 324.956 471.92 322.545 471.797 320.308C471.754 319.333 471.761 318.356 471.816 317.381C471.879 316.1 471.983 315.094 471.983 315.094L476.211 314.099L476.654 314.67L477.072 315.218C477.072 315.218 479.621 317.574 479.131 319.253Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.434 327.103H430.92C431.089 326.579 431.601 325.753 433.132 325.506C435.361 325.146 439.222 323.848 440.084 321.001C440.111 320.909 440.136 320.817 440.157 320.72C440.84 317.674 445.812 321.653 445.812 321.653C445.812 321.653 445.827 321.774 445.848 321.979C445.959 323.045 446.232 326.395 445.434 327.103Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.725 245.718C433.725 245.718 434.479 255.14 435.368 266.466C436.574 281.853 438.025 300.752 438.167 304.332C438.416 310.549 439.411 320.495 439.411 320.495C439.411 320.495 441.774 322.857 446.499 321.862C446.499 321.862 450.71 307.664 451.912 292.645L451.968 291.903C453.087 276.612 454.826 244.411 454.826 244.411L433.725 245.718Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.725 245.718C433.725 245.718 434.479 255.14 435.368 266.466L451.912 292.645L451.968 291.903C453.087 276.612 454.826 244.411 454.826 244.411L433.725 245.718Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.178 246.836C437.178 246.836 450.79 280.962 459.741 296.998C468.691 313.033 471.489 317.511 471.489 317.511C471.489 317.511 476.617 315.46 477.084 314.062C477.084 314.062 473.661 283.101 467.675 275.554C464.288 271.289 460.31 258.492 460.124 254.02C459.937 249.548 458.911 240.688 458.911 240.688L437.178 246.836Z",
    fill: "#2B478B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.406 237.416L422.628 238.967C422.628 238.967 418.671 239.519 419.76 243.644C419.76 243.644 420.347 245.341 421.433 244.804C422.518 244.267 421.985 244.313 423.548 243.589C425.112 242.866 426.018 241.478 425.668 240.205L425.919 238.854L423.406 237.416Z",
    fill: "#AB7041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.155 194.16C443.551 190.587 443.528 188.469 443.528 188.469L450.427 182.902C450.172 190.556 455.075 194.237 455.075 194.237C455.075 194.237 445.876 198.768 440.551 197.089C441.563 195.9 442.785 194.907 444.155 194.16Z",
    fill: "#9C5F33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.903 188.342C441.903 188.342 450.684 189.805 451.521 184.317C452.357 178.829 454.03 175.327 448.46 174.161C442.89 172.994 441.477 174.926 440.756 176.69C440.034 178.455 439.639 187.821 441.903 188.342Z",
    fill: "#AB7041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.458 184.698C451.458 184.698 451.28 177.349 443.275 176.17C437.791 175.361 441.111 170.78 441.738 170.052C441.738 170.052 445.93 170.853 450.22 171.794C459.227 173.77 452.409 183.602 451.458 184.698Z",
    fill: "#0F538D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.328 239.571C423.541 238.728 422.854 237.797 422.281 236.797C422.281 236.797 432.264 224.393 433.076 223.107C433.887 221.822 439.95 201.189 439.95 201.189L455.284 198.078C455.284 198.078 442.486 224.481 440.366 227.7C436.862 233.019 426.379 240.934 426.379 240.934C425.612 240.62 424.915 240.156 424.328 239.571Z",
    fill: "#74ACBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.137 246.502C433.292 246.636 433.491 246.71 433.697 246.711C435.694 246.684 441.518 247.794 446.451 247.288C450.605 246.889 454.284 245.657 458.234 243.886C458.757 243.652 459.965 243.008 459.938 242.423C459.921 241.781 459.856 240.851 459.777 239.678C459.497 235.601 459.01 228.597 459.484 220.5C459.57 218.995 459.614 217.5 459.62 216.028C459.662 205.065 457.508 195.27 453.139 192.007C452.767 191.739 450.454 193.01 448.349 194.049C446.574 194.924 444.554 195.168 442.622 194.741L440.785 196.366C438.548 198.444 436.097 201.268 435.031 205.565C434.124 209.213 433.592 215.794 433.3 222.614C433.166 225.704 433.059 228.821 433.032 231.777V231.884C433.005 232.177 433.005 232.497 433.005 232.789C432.896 240.374 432.997 246.395 433.137 246.502Z",
    fill: "#9ED9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.775 239.682C459.495 235.605 459.008 228.602 459.482 220.504C459.568 218.999 459.612 217.504 459.618 216.033C457.799 211.619 456.311 208.416 456.311 208.416H451.724C451.724 208.416 448.362 231.384 459.775 239.682Z",
    fill: "#74ACBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.346 260.764L491.792 249.305C491.272 247.649 490.117 246.267 488.581 245.459C487.045 244.651 485.252 244.483 483.592 244.992L457.151 253.211C455.494 253.731 454.111 254.886 453.303 256.422C452.496 257.959 452.329 259.753 452.84 261.412L456.394 272.871C456.914 274.528 458.069 275.911 459.606 276.718C461.142 277.526 462.936 277.693 464.596 277.182L491.037 268.964C492.693 268.443 494.075 267.289 494.882 265.752C495.69 264.216 495.856 262.423 495.346 260.764Z",
    fill: "#D86713"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.87 259.807L495.268 248.214C494.746 246.552 493.587 245.164 492.045 244.353C490.502 243.542 488.702 243.374 487.037 243.886L477.948 246.711L477.181 244.24C477.009 243.69 476.627 243.231 476.117 242.963C475.608 242.695 475.013 242.64 474.463 242.81L473.944 242.971L469.215 244.434L466.566 245.258C466.017 245.43 465.558 245.812 465.291 246.322C465.023 246.831 464.968 247.426 465.138 247.976L465.906 250.447L460.641 252.084C460.441 252.143 460.244 252.213 460.052 252.293H460.041L460.014 252.305C458.519 252.947 457.314 254.119 456.631 255.596C455.948 257.072 455.835 258.749 456.313 260.304L459.916 271.897C460.364 273.324 461.284 274.556 462.525 275.392C463.765 276.227 465.253 276.617 466.744 276.496C467.219 276.458 467.688 276.367 468.143 276.225H468.155L494.538 268.025C496.199 267.504 497.586 266.348 498.397 264.808C499.209 263.269 499.379 261.471 498.87 259.807ZM467.204 250.05L466.437 247.578C466.405 247.477 466.394 247.37 466.403 247.264C466.413 247.158 466.443 247.055 466.493 246.961C466.542 246.867 466.61 246.783 466.692 246.715C466.774 246.647 466.868 246.596 466.97 246.564L469.543 245.764L473.934 244.396L474.858 244.11C474.936 244.085 475.017 244.073 475.099 244.072C475.272 244.073 475.44 244.128 475.579 244.231C475.718 244.333 475.821 244.478 475.872 244.643L476.642 247.114L467.204 250.05Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.697 241.108L469.569 242.609C469.569 242.609 467.863 246.222 471.909 247.57C471.909 247.57 473.65 248.011 473.79 246.803C473.93 245.594 473.684 246.071 473.937 244.367C474.19 242.663 473.519 241.146 472.264 240.74L471.271 239.791L468.697 241.108Z",
    fill: "#AB7041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.007 241.518C469.871 241.713 468.716 241.778 467.565 241.71C467.565 241.71 462.66 226.561 462.031 225.179C461.402 223.797 447.465 207.408 447.465 207.408L453.269 192.88C453.269 192.88 468.341 218.056 469.871 221.594C472.401 227.447 473.277 240.545 473.277 240.545C472.592 241.016 471.82 241.346 471.007 241.518Z",
    fill: "#9ED9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.891 250.905C139.676 250.726 144.652 250.635 149.818 250.631C149.818 250.631 178.413 225.815 211.495 217.37C177.481 225.769 134.891 250.905 134.891 250.905Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.879 269.532V242.145C393.879 242.145 361.736 238.471 342.297 231.432C297.306 214.891 273.11 214.594 232.243 214.594C201.214 214.594 169.788 235.373 156.453 245.379C151.953 248.747 146.51 250.62 140.89 250.737C91.8058 251.814 61.4629 261.609 46.3887 268.226C42.934 269.747 39.9969 272.241 37.9356 275.403C35.8744 278.565 34.7783 282.259 34.781 286.034V295.258C34.2941 295.258 33.8272 295.451 33.483 295.796C33.1387 296.14 32.9453 296.607 32.9453 297.094V312.401C32.9453 312.888 33.1387 313.355 33.483 313.699C33.8272 314.044 34.2941 314.237 34.781 314.237H64.0722C61.0655 308.855 59.5653 302.763 59.7297 296.6C60.1876 278.332 75.1092 263.455 93.378 263.051C99.4432 262.913 105.437 264.38 110.753 267.302C116.07 270.225 120.519 274.5 123.652 279.695C126.785 284.89 128.49 290.821 128.594 296.886C128.698 302.952 127.198 308.938 124.246 314.237H304.467C301.461 308.855 299.962 302.762 300.127 296.6C300.585 278.332 315.506 263.455 333.775 263.051C339.84 262.913 345.834 264.38 351.15 267.302C356.467 270.225 360.916 274.5 364.049 279.695C367.182 284.89 368.887 290.821 368.991 296.886C369.095 302.952 367.595 308.938 364.643 314.237H371.839C396.742 314.237 400.273 288.771 400.505 276.283C400.522 275.403 400.363 274.527 400.038 273.709C399.712 272.89 399.227 272.145 398.61 271.516C397.993 270.888 397.257 270.389 396.445 270.048C395.632 269.707 394.76 269.532 393.879 269.532Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.466 219.532C188.032 226.726 157.547 251.31 157.547 251.31L238.249 249.586C239.801 249.552 241.312 249.083 242.611 248.233C243.91 247.383 244.944 246.186 245.596 244.777L257.961 218.092H228.036C224.135 218.091 220.248 218.575 216.466 219.532Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.702 218.717L251.372 244.67C251.171 245.13 251.088 245.632 251.13 246.132C251.171 246.632 251.337 247.114 251.612 247.534C251.887 247.954 252.262 248.299 252.703 248.537C253.145 248.775 253.639 248.9 254.141 248.9C265.573 248.9 295.589 248.482 312.869 244.152C317.019 243.106 318.412 237.88 315.324 234.928C308.303 228.183 293.035 218.717 262.702 218.717Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8867 277.222H48.6785C48.6785 277.222 67.953 259.225 98.8958 254.124C98.8958 254.124 41.7414 260.423 36.8867 277.222Z",
    fill: "#B64C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88 269.533H390.762C389.906 269.534 389.067 269.292 388.343 268.835C387.619 268.378 387.04 267.724 386.673 266.951C384.869 263.133 380.907 255.883 374.827 250.729C372.473 248.735 373.882 244.89 376.968 244.89H393.884L393.88 269.533Z",
    fill: "#B64C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.092 257.212H223.412C223.206 257.212 223.002 257.172 222.811 257.093C222.621 257.014 222.448 256.898 222.302 256.752C222.157 256.606 222.041 256.433 221.963 256.243C221.884 256.052 221.843 255.848 221.844 255.642C221.844 255.226 222.009 254.828 222.303 254.533C222.597 254.239 222.996 254.074 223.412 254.074H239.092C239.298 254.074 239.503 254.114 239.693 254.193C239.884 254.272 240.057 254.387 240.202 254.533C240.348 254.678 240.464 254.851 240.543 255.042C240.622 255.232 240.662 255.436 240.662 255.642C240.662 256.059 240.497 256.458 240.203 256.752C239.908 257.047 239.509 257.212 239.092 257.212Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.432 257.212H292.752C292.546 257.212 292.341 257.172 292.151 257.093C291.961 257.014 291.788 256.898 291.642 256.752C291.497 256.606 291.381 256.433 291.302 256.243C291.224 256.052 291.183 255.848 291.184 255.642C291.184 255.226 291.349 254.828 291.643 254.533C291.937 254.239 292.336 254.074 292.752 254.074H308.432C308.848 254.074 309.247 254.239 309.541 254.533C309.835 254.828 310 255.226 310 255.642C310 255.848 309.96 256.052 309.881 256.243C309.803 256.433 309.687 256.606 309.542 256.752C309.396 256.898 309.223 257.014 309.033 257.093C308.842 257.172 308.638 257.212 308.432 257.212Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.153 267.39H153.742C147.888 267.39 144.298 273.787 147.336 278.784L156.444 293.753C156.912 294.523 157.534 295.188 158.27 295.707C159.007 296.227 159.843 296.588 160.726 296.77C161.608 296.952 162.519 296.95 163.401 296.764C164.283 296.579 165.117 296.213 165.852 295.691C177.949 287.071 212.778 269.188 295.153 267.39Z",
    fill: "#DD7F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.384 87.6531C374.416 87.6531 367.733 90.4209 362.806 95.3477C357.879 100.275 355.111 106.957 355.111 113.924C355.111 128.434 381.384 154.508 381.384 154.508C381.384 154.508 407.656 128.434 407.656 113.924C407.656 106.957 404.888 100.275 399.961 95.3477C395.034 90.4209 388.351 87.6531 381.384 87.6531ZM381.384 129.466C377.858 129.466 374.412 128.421 371.48 126.462C368.549 124.504 366.264 121.72 364.915 118.463C363.566 115.206 363.213 111.622 363.9 108.164C364.588 104.706 366.286 101.53 368.779 99.0372C371.272 96.5443 374.448 94.8466 377.906 94.1588C381.364 93.4711 384.948 93.8241 388.205 95.1732C391.462 96.5223 394.246 98.807 396.205 101.738C398.164 104.67 399.209 108.116 399.209 111.641C399.21 113.983 398.75 116.302 397.855 118.466C396.96 120.63 395.647 122.596 393.992 124.252C392.336 125.909 390.371 127.223 388.207 128.119C386.044 129.015 383.725 129.477 381.384 129.477V129.466Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.567 327.103H0.432782C0.193763 327.103 0 327.297 0 327.536V327.567C0 327.806 0.193763 328 0.432782 328H538.567C538.806 328 539 327.806 539 327.567V327.536C539 327.297 538.806 327.103 538.567 327.103Z",
    fill: "#283250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.544 201.44H236.292C235.829 201.44 235.378 201.583 235 201.849C234.621 202.115 234.335 202.491 234.178 202.926L229.902 214.803H245.792V203.679C245.79 203.084 245.552 202.515 245.131 202.095C244.709 201.675 244.139 201.44 243.544 201.44Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.791 214.621V206.493H242.68C241.633 206.493 240.611 206.816 239.755 207.42C238.899 208.023 238.251 208.876 237.899 209.863L236.201 214.621H245.791Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.921 271.418H202.189V282.15H212.921V271.418Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.652 282.15H212.92V292.881H223.652V282.15Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.386 271.418H223.654V282.15H234.386V271.418Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.118 282.15H234.387V292.881H245.118V282.15Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.849 271.418H245.117V282.15H255.849V271.418Z",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.886 303.196H400.89C399.65 303.195 398.461 302.702 397.583 301.825C396.706 300.949 396.213 299.76 396.211 298.52V273.415C396.213 272.175 396.706 270.986 397.583 270.109C398.461 269.232 399.65 268.739 400.89 268.738H407.886C409.125 268.74 410.314 269.233 411.191 270.11C412.068 270.986 412.561 272.175 412.563 273.415V298.52C412.561 299.759 412.068 300.948 411.191 301.825C410.314 302.701 409.125 303.195 407.886 303.196ZM400.89 269.997C399.981 269.997 399.109 270.359 398.465 271.001C397.822 271.644 397.46 272.516 397.459 273.425V298.53C397.46 299.44 397.822 300.312 398.465 300.955C399.108 301.598 399.98 301.96 400.89 301.961H407.886C408.795 301.96 409.667 301.598 410.31 300.955C410.952 300.311 411.314 299.439 411.314 298.53V273.415C411.313 272.506 410.952 271.634 410.309 270.992C409.666 270.349 408.795 269.987 407.886 269.986L400.89 269.997Z",
    fill: "#66A357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.318 322.656H408.254C407.672 322.656 407.113 322.888 406.702 323.299C406.29 323.711 406.059 324.269 406.059 324.851C406.059 325.434 406.29 325.992 406.702 326.404C407.113 326.815 407.672 327.047 408.254 327.047H409.318C409.9 327.047 410.459 326.815 410.87 326.404C411.282 325.992 411.513 325.434 411.513 324.851C411.513 324.269 411.282 323.711 410.87 323.299C410.459 322.888 409.9 322.656 409.318 322.656Z",
    fill: "#66A357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.154 326.872C411.272 326.409 411.803 325.128 411.34 324.01C410.877 322.892 409.595 322.361 408.477 322.824C407.359 323.287 406.829 324.569 407.292 325.687C407.755 326.805 409.036 327.335 410.154 326.872Z",
    fill: "#A8D29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.803 322.656H394.734C394.152 322.656 393.594 322.888 393.182 323.299C392.77 323.711 392.539 324.269 392.539 324.851C392.539 325.434 392.77 325.992 393.182 326.404C393.594 326.815 394.152 327.047 394.734 327.047H395.799C396.381 327.047 396.939 326.815 397.351 326.404C397.763 325.992 397.994 325.434 397.994 324.851C397.994 324.269 397.763 323.711 397.351 323.299C396.939 322.888 396.381 322.656 395.799 322.656H395.803Z",
    fill: "#66A357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.641 326.872C397.759 326.409 398.29 325.127 397.827 324.009C397.364 322.891 396.082 322.36 394.964 322.823C393.846 323.286 393.315 324.568 393.778 325.686C394.241 326.804 395.523 327.335 396.641 326.872Z",
    fill: "#A8D29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.106 282.927H398.694C394.611 282.927 391.301 286.237 391.301 290.32V316.075C391.301 320.158 394.611 323.468 398.694 323.468H412.106C416.189 323.468 419.499 320.158 419.499 316.075V290.32C419.499 286.237 416.189 282.927 412.106 282.927Z",
    fill: "#66A357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.18 282.927H392.768C388.685 282.927 385.375 286.237 385.375 290.32V316.075C385.375 320.158 388.685 323.468 392.768 323.468H406.18C410.263 323.468 413.573 320.158 413.573 316.075V290.32C413.573 286.237 410.263 282.927 406.18 282.927Z",
    fill: "#A8D29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.98 317.542H387.57C386.899 317.542 386.23 317.634 385.584 317.816C385.976 319.426 386.897 320.858 388.199 321.881C389.502 322.905 391.111 323.461 392.768 323.461H406.178C406.85 323.461 407.519 323.369 408.166 323.187C407.774 321.578 406.852 320.146 405.549 319.123C404.246 318.099 402.637 317.543 400.98 317.542Z",
    fill: "#82B378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.608 283.343H410.275V282.925H396.704C395.16 283.451 393.819 284.446 392.869 285.772C391.919 287.097 391.407 288.687 391.404 290.318V316.071C391.406 317.702 391.919 319.292 392.869 320.618C393.819 321.944 395.16 322.939 396.704 323.465H410.275V323.047H409.608C407.758 323.045 405.985 322.309 404.677 321.001C403.369 319.692 402.633 317.919 402.632 316.069V290.32C402.634 288.47 403.369 286.697 404.677 285.389C405.985 284.081 407.759 283.346 409.608 283.343ZM406.108 323.051H399.209C397.359 323.049 395.585 322.313 394.277 321.005C392.969 319.697 392.234 317.923 392.232 316.073V290.32C392.234 288.47 392.97 286.697 394.278 285.389C395.586 284.081 397.359 283.346 399.209 283.343H406.108C404.814 283.993 403.726 284.989 402.965 286.221C402.205 287.453 401.801 288.872 401.799 290.32V316.073C401.801 317.521 402.204 318.94 402.965 320.173C403.726 321.405 404.814 322.401 406.108 323.051Z",
    fill: "#66A357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.019 318.661C367.716 306.964 367.716 287.999 356.019 276.302C344.321 264.604 325.355 264.604 313.657 276.302C301.959 287.999 301.959 306.964 313.657 318.661C325.355 330.359 344.321 330.359 356.019 318.661Z",
    fill: "#2D3A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.837 278.922C331.166 278.922 327.578 280.01 324.526 282.049C321.474 284.089 319.095 286.987 317.69 290.378C316.285 293.769 315.918 297.501 316.634 301.101C317.35 304.701 319.118 308.008 321.713 310.604C324.309 313.199 327.616 314.967 331.216 315.683C334.816 316.399 338.548 316.031 341.939 314.627C345.331 313.222 348.229 310.843 350.268 307.791C352.308 304.739 353.396 301.151 353.396 297.48C353.396 292.558 351.441 287.838 347.96 284.357C344.48 280.877 339.759 278.922 334.837 278.922ZM337.379 280.956C341.329 281.562 344.93 283.565 347.528 286.601L341.094 290.573C340.032 289.608 338.76 288.903 337.379 288.512V280.956ZM332.294 280.956V288.516C330.914 288.907 329.642 289.612 328.579 290.577L322.146 286.605C324.743 283.567 328.344 281.563 332.294 280.956ZM319.424 303.953C318.557 301.888 318.114 299.669 318.119 297.429C318.125 295.189 318.58 292.973 319.457 290.912L325.886 294.884C325.404 296.547 325.396 298.312 325.863 299.979L319.424 303.953ZM332.294 313.988C328.315 313.376 324.69 311.346 322.09 308.272L328.514 304.3C329.59 305.295 330.885 306.021 332.294 306.42V313.988ZM330.622 297.472C330.622 296.639 330.869 295.824 331.332 295.132C331.795 294.439 332.453 293.899 333.223 293.58C333.992 293.261 334.839 293.178 335.657 293.34C336.474 293.503 337.224 293.904 337.814 294.493C338.403 295.082 338.804 295.833 338.967 296.65C339.129 297.467 339.046 298.314 338.727 299.084C338.408 299.854 337.868 300.512 337.175 300.975C336.482 301.438 335.668 301.685 334.835 301.685C333.719 301.684 332.65 301.241 331.861 300.453C331.071 299.664 330.627 298.596 330.624 297.48L330.622 297.472ZM337.377 313.988V306.426C338.787 306.028 340.082 305.301 341.157 304.306L347.582 308.279C344.983 311.356 341.36 313.39 337.379 314.005L337.377 313.988ZM343.81 299.968C344.276 298.301 344.267 296.536 343.785 294.873L350.214 290.901C351.091 292.962 351.546 295.178 351.552 297.419C351.558 299.659 351.114 301.877 350.248 303.943L343.81 299.968Z",
    fill: "#98BDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.376 318.87C127.074 307.173 127.074 288.207 115.376 276.51C103.678 264.813 84.7124 264.813 73.0146 276.51C61.3169 288.207 61.3169 307.173 73.0146 318.87C84.7124 330.567 103.678 330.567 115.376 318.87Z",
    fill: "#2D3A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1942 279.131C90.5235 279.131 86.9352 280.219 83.8832 282.258C80.8311 284.298 78.4522 287.196 77.0475 290.587C75.6428 293.978 75.2753 297.71 75.9914 301.31C76.7075 304.91 78.4751 308.217 81.0707 310.813C83.6663 313.408 86.9733 315.176 90.5735 315.892C94.1736 316.608 97.9053 316.24 101.297 314.836C104.688 313.431 107.587 311.052 109.626 308C111.665 304.948 112.754 301.36 112.754 297.689C112.754 292.767 110.798 288.047 107.318 284.566C103.837 281.086 99.1165 279.131 94.1942 279.131ZM96.7366 281.165C100.686 281.771 104.287 283.774 106.885 286.81L100.452 290.782C99.3891 289.817 98.1175 289.112 96.7366 288.721V281.165ZM91.6519 281.165V288.725C90.271 289.116 88.9994 289.821 87.9367 290.786L81.5035 286.814C84.1007 283.776 87.7018 281.772 91.6519 281.165ZM78.7813 304.162C77.9147 302.097 77.4711 299.878 77.4768 297.638C77.4826 295.398 77.9375 293.182 78.8148 291.121L85.2438 295.093C84.7612 296.756 84.7532 298.521 85.2208 300.188L78.7813 304.162ZM91.6519 314.197C87.6721 313.585 84.0478 311.555 81.447 308.481L87.8719 304.509C88.9471 305.504 90.2424 306.23 91.6519 306.629V314.197ZM89.9793 297.681C89.9793 296.848 90.2264 296.033 90.6893 295.341C91.1522 294.648 91.8102 294.108 92.58 293.789C93.3498 293.47 94.1968 293.387 95.014 293.549C95.8312 293.712 96.5819 294.113 97.1711 294.702C97.7602 295.291 98.1615 296.042 98.324 296.859C98.4866 297.676 98.4031 298.523 98.0843 299.293C97.7654 300.063 97.2255 300.721 96.5327 301.184C95.8399 301.647 95.0254 301.894 94.1921 301.894C93.0768 301.893 92.0074 301.45 91.2181 300.662C90.4289 299.873 89.9842 298.805 89.9814 297.689L89.9793 297.681ZM96.7345 314.197V306.635C98.144 306.237 99.4392 305.51 100.515 304.515L106.939 308.488C104.341 311.565 100.717 313.599 96.7366 314.214L96.7345 314.197ZM103.168 300.177C103.633 298.51 103.625 296.745 103.143 295.082L109.572 291.11C110.449 293.171 110.904 295.387 110.91 297.628C110.915 299.868 110.472 302.086 109.605 304.152L103.168 300.177Z",
    fill: "#98BDF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_3200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 539,
    height: 328,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmTrip);
export default __webpack_public_path__ + "static/media/confirmTrip.e9aaba7dc81a25e3c4bc85cf35d1f413.svg";
export { ForwardRef as ReactComponent };